import React from 'react';
import qs from 'qs';
import merge from 'lodash/merge';
import Form from '../Form.js';
import { stringifyFacets } from '../../../utils/products.js';
import { generateEvent } from '../../../utils/dataGrinch';

class MinMaxFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.facetItemsConfig = {
      itemsVisible: 5
    };
  }

  /**
   *  FacetQuery with key (pricerange) is appended on click of checckbox under price facet
   *  whereas the key (price) is appended due to explicit input of price inside input area.
   *
   *  That's why this method has only check for (price) so that the form used for price input area
   *  can be prefilled with default values.
   */
  getPriceFormDefaultValues = () => {
    const { facetsQuery = {} } = this.props;
    const priceFacet = facetsQuery[this.props.code] ? facetsQuery[this.props.code][0] : null;
    if (priceFacet) {
      const priceRangeSplits = priceFacet.split(',');
      return {
        minPrice: priceRangeSplits[0] || '',
        maxPrice: priceRangeSplits[1] || ''
      };
    }
    return {
      minPrice: '',
      maxPrice: ''
    };
  };

  getFacetsQuery() {
    const { facetsQuery } = this.props;
    return merge({}, facetsQuery);
  }

  render() {
    return (
      <Form
        getFormState={() => {
          const { priceFormState = {} } = this.state;
          const nextPriceFormState = { ...priceFormState };
          nextPriceFormState.formValues =
            nextPriceFormState.formValues || this.getPriceFormDefaultValues();
          return nextPriceFormState;
        }}
        setFormState={(nextFormState, done) => {
          const prevFormState = this.state.priceFormState || {};
          this.setState({ priceFormState: { prevFormState, ...nextFormState } }, done);
        }}
        onSubmit={formValues => {
          const { priceFormState = {} } = this.state;
          const facetsQuery = this.getFacetsQuery();

          generateEvent({
            Event: 'Filter',
            value: {
              'ListOfFilters:': qs.stringify(facetsQuery)
            }
          });
          /**
           * Setting query (price)
           */
          facetsQuery[this.props.code] = [`${formValues.minPrice},${formValues.maxPrice}`];
          this.props.setCurentFacetsQuery(facetsQuery);
          this.props.pushToHistory({
            facets: stringifyFacets(facetsQuery),
            currentPage: 0
          });
          this.setState({
            priceFormState: { ...priceFormState, formValues: null }
          });
        }}
        validateForm={formValues => {
          let { minPrice, maxPrice } = formValues;
          minPrice = parseInt(minPrice);
          maxPrice = parseInt(maxPrice);
          if (minPrice == 0 && maxPrice > 0) {
            return {};
          } else if (minPrice > maxPrice) {
            return {
              error: `Min ${this.props.code} cannot be greater than Max ${this.props.code}`
            };
          } else if (minPrice == maxPrice) {
            return { error: `Min and Max ${this.props.code} cannot be same` };
          } else if (!minPrice || !maxPrice) {
            return { error: `Please enter your ${this.props.code} range` };
          } else {
            return {};
          }
        }}
      >
        {({
          getFormDefaultProps,
          getFormValue,
          isTouched,
          addFormValue,
          formValues,
          formError,
          resetAll
        }) => {
          return (
            <div className="price-container">
              <div className="input-price-filter">
                <div className="price-range-title" role="heading" aria-level={2}>
                  <span>
                    {`Enter ${this.props.code} Range`}
                  </span>
                  <span
                    className="clear-all"
                    onClick={e => {
                      resetAll();
                      const facetsQuery = this.getFacetsQuery();

                      if (facetsQuery && facetsQuery[this.props.code]) {
                        delete facetsQuery[this.props.code];
                        this.props.setCurentFacetsQuery(facetsQuery);
                        this.props.pushToHistory({
                          facets: stringifyFacets(facetsQuery),
                          currentPage: 0
                        });
                      }
                      e.stopPropagation();
                    }}
                    aria-label="Clear"
                  >
                    Clear
                  </span>
                </div>
                <div className="facet-min-price-filter">
                  <input
                    {...getFormDefaultProps({
                      type: 'text',
                      pattern: 'd*',
                      name: 'minPrice'
                    })}
                    onChange={event => {
                      const { name, value } = event.target;
                      const isNum = /^\d+$/.test(value);
                      if (value != null && isNum) {
                        addFormValue(name, value);
                      } else if (value == '') {
                        addFormValue(name, value);
                      }
                    }}
                    autoComplete="off"
                    id="minPrice"
                    placeholder="Min"
                    maxLength="6"
                    aria-label="Min"
                  />
                  <span className="ic-price-separator" />
                  <input
                    {...getFormDefaultProps({
                      type: 'text',
                      pattern: 'd*',
                      name: 'maxPrice'
                    })}
                    onChange={event => {
                      const { name, value } = event.target;
                      const isNum = /^\d+$/.test(value);
                      if (value != null && isNum) {
                        addFormValue(name, value);
                      } else if (value == '') {
                        addFormValue(name, value);
                      }
                    }}
                    autoComplete="off"
                    placeholder="Max"
                    id="maxPrice"
                    maxLength="6"
                    aria-label="Max"
                  />
                  <button
                    type="submit"
                    className="rilrtl-button ic-toparw"
                    aria-label="Apply price filter"
                  />
                </div>
                <div className="price-error">{formError.error}</div>
              </div>
            </div>
          );
        }}
      </Form>
    );
  }
}

export default MinMaxFilter;
